<template>
  <div>
    <el-input
      v-model="pageIfon.keywords"
      clearable
      style="width:400px;margin:10px 0px"
      placeholder="请输入企业名称/企业id"
    />
    <el-button
      type="primary"
      style="margin-left:10px"
      icon="el-icon-search"
      @click="searchclick"
    >搜索</el-button>
    <el-button
      type="info"
      icon="el-icon-refresh-right"
      @click="rechargeclick"
    >重置</el-button>
    <el-table
      v-loading="loading"
      :data="tableData"
      max-height="500"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="corp_name"
        label="企业名称"
        width="260"
        align="center"
      />
      <el-table-column
        prop="corp_id"
        label="企业id"
        width="320"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="editConfig(scope.row.corp_id)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="pageIfon.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { pullConfigList, pullConfig } from '@/api/tencentAccountIni'

export default {
  components: { PaginationRight },
  data() {
    return {
      total: null,
      loading: false,
      tableData: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        keywords: null
      }
    }
  },
  methods: {
    async send() {
      this.list()
    },
    async list() {
      this.loading = true
      const data = await pullConfigList(this.pageIfon)
      this.total = data.data.total
      this.tableData = data.data.list
      this.loading = false
    },
    async editConfig(id) {
      const data = await pullConfig({ corp_id: id })
      if (data.code === 200) {
        this.$message.success('拉取配置成功')
        this.list()
        this.$emit('update')
      } else {
        this.$message.error('拉取配置失败')
      }
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.list()
    },
    searchclick() {
      this.pageIfon.page = 1
      this.list()
    },
    rechargeclick() {
      this.pageIfon.page = 1
      this.pageIfon.keywords = null
      this.list()
    }
  }
}
</script>